// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"397":"88800f17","955":"62ca4f7d"}[chunkId] + ".chunk.css";
};